/// <amd-module name="Dashboards/DashboardView/src/model/PresentationMode" />
/** Provides a description of what the UI should currently be presenting. This is a simplification of the underlying state. */
export enum PresentationMode {
    View,
    Edit,
    Config,
    Copy
}
